import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-copy",
  "use": "icon-copy-usage",
  "viewBox": "0 0 469.333 469.333",
  "content": "<symbol viewBox=\"0 0 469.333 469.333\" fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-copy\">\r\n  <path d=\"M330.667,0h-256C51.093,0,32,19.093,32,42.667v298.667h42.667V42.667h256V0z\" />\r\n  <path d=\"M394.667,85.333H160c-23.573,0-42.667,19.093-42.667,42.667v298.667c0,23.573,19.093,42.667,42.667,42.667h234.667\r\n    c23.573,0,42.667-19.093,42.667-42.667V128C437.333,104.427,418.24,85.333,394.667,85.333z M394.667,426.667H160V128h234.667\r\n    V426.667z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol